<article class="feed-card-container">
    <div class="flex w-full min-w-0 flex-row items-start justify-between gap-3">

        <div class="flex min-w-0 flex-1 items-center">

            <div class="shrink-0">
                <img [src]="imageService.getImageSource(activity.briefApplication.creator?.photoURL, 'gallery')" alt=""
                    class="size-12 rounded-full bg-gray-50 dark:bg-gray-800 dark:outline dark:-outline-offset-1 dark:outline-white/10" />
            </div>

            <div class="ml-3 min-w-0 flex-1">
                <div class="flex min-w-0 flex-row items-center gap-x-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-4 shrink-0 text-orange-700">
                        <path d="M12 13v8" />
                        <path d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" />
                        <path d="m8 17 4-4 4 4" />
                    </svg>
                    <h3 class="truncate text-base font-semibold text-primary">
                        {{ activity.briefApplication.creator?.firstName }} {{
                        activity.briefApplication.creator?.lastName }}</h3>
                </div>
                <p class="text-sm text-secondary">
                    Ready to post!
                </p>
            </div>
        </div>

        <div class="flex shrink-0 flex-col items-start justify-start h-full">

            <p class="text-sm text-secondary">
                {{ activity.date ? formatService.getTimeSinceUpdated(activity.date) : '...'}}
            </p>
        </div>
    </div>

    <div class="flex min-w-0">
        <div (click)="viewContent(activity.video)" class="mr-4 shrink-0 w-32 overflow-hidden hover:cursor-pointer">
            <atom-video-thumbnail [videoUrl]="activity.video.fullUrl" [videoId]="activity.video.id"
                [thumbnailURL]="activity.video.thumbnailURL ? activity.video.thumbnailURL : undefined"
                [cdnKey]="activity.video.thumbnailCdnKey ? activity.video.thumbnailCdnKey : undefined"
                [videoFormat]="0"></atom-video-thumbnail>
        </div>
        <div class="flex min-w-0 w-full flex-col justify-between">
            <div class="w-full min-w-0 flex flex-col gap-y-2">
                <h4 class="truncate text-sm font-bold text-primary">Draft Name: {{ activity.video.videoName }}</h4>

                <div
                    class="rounded-md border border-orange-200/90 bg-orange-50 p-4 dark:border-orange-500/30 dark:bg-orange-500/10">
                    <div class="flex">
                        <div class="shrink-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5 text-orange-700 dark:text-orange-300">
                                <path d="M12 13v8" />
                                <path d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" />
                                <path d="m8 17 4-4 4 4" />
                            </svg>
                        </div>
                        <div class="ml-3">
                            <h3 class="text-sm font-medium text-orange-950 dark:text-orange-100">{{ getHandleAndNetwork()}}</h3>
                            @if (getIsUgcOnly()) {
                            <div class="mt-2 text-sm text-orange-900/90 dark:text-orange-100/85">
                                <p>The content is UGC ready! You may now download this content and use it in accordance with your license agreement.</p>
                            </div>
                            } @else {
                            <div class="mt-2 text-sm text-orange-900/90 dark:text-orange-100/85">
                                <p>The content is ready to be posted. The creator will post this content and share the relevent tracking information via the SHOUT eco-ssytem.</p>
                            </div>
                            }
                        </div>
                    </div>
                </div>

            </div>

            <div class="w-full flex flex-row items-center justify-end gap-x-2">
                <button type="button" (click)="viewContent(activity.video)"
                    class="inline-flex items-center gap-x-1.5 rounded-full bg-primary px-2.5 py-1.5 text-sm text-white shadow-xs hover:bg-primary/90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary dark:bg-primary dark:shadow-none dark:hover:bg-primary/90 dark:focus-visible:outline-primary">
                    View Content
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="-mr-0.5 size-5">
                        <path d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z" />
                    </svg>
                </button>
            </div>
        </div>
    </div>
</article>

@if (showVideoFeedback() && creator()) {
<vs-video-feedback (close)="closeVideoFeedback()" [video]="showVideoFeedback()" [creator]="creator()!"
    [isUgcOnly]="getIsUgcOnly()" [videoFormat]="activity.video.videoFormat"
    [briefApplication]="activity.briefApplication"></vs-video-feedback>
}